const URL_REGEX =
  /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{2,63}(?=[/?#]|$)([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;

export function isValidWebsiteUrl(value) {
  const url = String(value || "").trim();
  if (!url) return false;
  return URL_REGEX.test(url);
}

/** Canonical form for saved projects — fast.com and fast.com/ resolve the same. */
export function normalizeSiteUrl(rawUrl) {
  const trimmed = String(rawUrl || "").trim();
  if (!trimmed) return "";
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const u = new URL(withScheme);
    u.hostname = u.hostname.toLowerCase();
    const isRootOnly = !u.pathname || u.pathname === "/";
    if (isRootOnly && !u.search && !u.hash) {
      return `${u.protocol}//${u.hostname}`;
    }
    let path = u.pathname || "";
    if (path.length > 1 && path.endsWith("/")) {
      path = path.slice(0, -1);
    }
    return `${u.protocol}//${u.hostname}${path}${u.search}${u.hash}`;
  } catch {
    return trimmed;
  }
}

export function siteUrlsMatch(a, b) {
  return normalizeSiteUrl(a) === normalizeSiteUrl(b);
}

